import{objectSpread2 as r}from"../../_virtual/_rollupPluginBabelHelpers.min.mjs";const t=(t,a)=>{var e;const{transform:{target:o}}=a;null===(e=o.canvas)||void 0===e||e.fire("object:".concat(t),r(r({},a),{},{target:o})),o.fire(t,a)};export{t as fireEvent};
//# sourceMappingURL=fireEvent.min.mjs.map
